import moment from 'moment-timezone';
import Vue from 'vue';
import DateRangePicker from '../dateRangePicker/src/dateRangePicker.vue';

import template from 'raw-loader!./dateSelectionPopup.html';

let dateRangePopup = Vue.component('dateRangePopup', {
  name: 'DateRangePopup',
  template: template,
  props: {
    dateText: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default: function() {
        return {
          startDate: undefined,
          endDate: undefined
        };
      },
    },
    minDate: {
      type: Date,
      default: function() {
        return moment().subtract(10, 'year').startOf('month').toDate();
      }
    },
    maxDate: {
      type: Date,
      default: function() {
        return moment().toDate();
      }
    },
    isReadOnly: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      showDateRangePicker: false
    };
  },
  methods: {
    outsideClickListener: function(event) {
        let self = this;
        if (self.showDateRangePicker && this.$refs.dateRangePicker && !this.$refs.dateRangePicker.contains(event.target)) {
            self.showDateRangePicker = false;
            document.removeEventListener('click', self.outsideClickListener, true);
            event.stopImmediatePropagation();
        }
    },
    openDateRangePicker: function() {
      if (!this.isReadOnly) {
        if (!this.showDateRangePicker) {
            this.showDateRangePicker = true;
            setTimeout(() => document.addEventListener('click', this.outsideClickListener.bind(this), true), 0);
        } else {
          this.showDateRangePicker = false;
        }
      }
    },
    updateDateRange(range) {
      this.showDateRangePicker = false;
      this.$emit('range-selected', range);
    }
  },
  components: {
    'date-range-picker': DateRangePicker,
  },
});

export default dateRangePopup;
